const isIE = (doc) => false || !!doc.documentMode;

export default isIE;
